import { useSelector } from "react-redux";

export const useAuth = () => {
  const { loading, isAuthenticated, user} = useSelector((state) => state.authReducer);
  return {
    loading,
    isAuthenticated,
    user
  };
};